// Per-device, per-browser ack key. Falls back to "acknowledged" on storage
// errors — acceptable since re-seeing the modal once on a new device is an
// over-acknowledgement, not a UX failure.
const FIRST_LINK_ACK_KEY = "sill.plaid.firstLinkAck";

export function hasAcknowledgedFirstPlaidLink(): boolean {
  if (typeof window === "undefined") return true;
  try {
    return window.localStorage.getItem(FIRST_LINK_ACK_KEY) === "1";
  } catch {
    // Private-browsing / quota errors → assume acknowledged so the modal
    // doesn't loop every link. Toast-only is the safer fallback.
    return true;
  }
}

export function acknowledgeFirstPlaidLink(): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(FIRST_LINK_ACK_KEY, "1");
  } catch {
    // Best-effort; see hasAcknowledgedFirstPlaidLink.
  }
}
